"use strict";
import { FiatOnRampTransactionStatus } from "state/fiatOnRampTransactions/types";
import { TransactionStatus } from "uniswap/src/data/graphql/uniswap-data-api/__generated__/types-and-hooks";
export function statusToTransactionInfoStatus(status) {
  switch (status) {
    case "FAILED":
    case "ERROR":
    case "VOIDED":
      return FiatOnRampTransactionStatus.FAILED;
    case "SETTLED":
      return FiatOnRampTransactionStatus.COMPLETE;
    default:
      return FiatOnRampTransactionStatus.PENDING;
  }
}
export function forTransactionStatusToTransactionStatus(status) {
  switch (status) {
    case FiatOnRampTransactionStatus.FAILED:
      return TransactionStatus.Failed;
    case FiatOnRampTransactionStatus.COMPLETE:
      return TransactionStatus.Confirmed;
    case FiatOnRampTransactionStatus.PENDING:
    default:
      return TransactionStatus.Pending;
  }
}
